  export const normalizeSource = (source) => {
    if (!source) return "";
    const s = source.toLowerCase();
    if (s.includes("ryhti") || s.includes("maanmittauslaitos")) {
    return "Julkinen rekisteri";
    }
    return source;
};
